import React, { useState, useRef, useEffect } from "react";
import RedoSubject from "./re_registration_sub/RedoSubject";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { submitReRegistrationService } from "../../services/ReRegistrationService";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setReRegistrationsReload } from "../../store/actions";
import DigitalSignatureComponent from "../common/DigitalSignatureComponent";
import StudentTypeButton from "./components/StudentTypeButton";
import { getFoundationOptions } from "../../utils/CommonGroupingItem";
import axios from "axios";
import { StandardButton } from "../common/GlobalElements/StandardButton";
import { TextLink } from "../common/GlobalElements/Typography";

function StandardReReg(props) {
  const { reRegSubject, setReadOnly, setStudentNewRegId, registration, lateReg, qualificationDetails } = props;
  const { regid } = useParams()
  
  const [parentSubjectRedoLength, setParentSubjectRedoLength] = useState([
    { subject: "" },
  ]);
  
  const [disableProgress, setDisableProgress] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [foundationOptions, setFoundationOptions] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const isReReg = useSelector(state=>state.isReReg);
  const reload = useSelector(state => state.registrations.reload);
  const [foundationReReg, setFoundReReg] = useState([
    { subject: "" },
  ]);
  const [foundationProgress, setFoundProgress] = useState([
    { subject: "" },
  ]);
  
  const [isSig, setIsSig] = useState("")
  const signaturePadRef = useRef(null);
  const fileInputRef = useRef(null);
  const [ipAddress, setIpAddress] = useState('');
  const [cDate,setCDate] = useState('')
  const [isCancel,setIsCancel] = useState(false)
  const [studentType, setStudentType] = useState(-1);
  const [selectedNSId, setSelectedNSId] = useState("");
  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };
  const handleFoundProgressChange = (index, value) => {    
    const values = [...foundationProgress];
    values[index].subject = value;
    if(values.length == 1){
      const selectedOption = foundationOptions.find(opt => opt.id == value);
      if (selectedOption) {
        setSelectedNSId(selectedOption.netsuite_id);
      }else{
        setSelectedNSId("");
      }      
    }else{
      setSelectedNSId("");
    }
    setFoundProgress(values);
  };
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subjectProgress_: foundationProgress,
      subjectRedo_: parentSubjectRedoLength,
      rereg_academy: props.registration.academy,
      delivery_methode: qualificationDetails?.type || "",
      campus: qualificationDetails?.campus || "",     
      building_id: qualificationDetails?.building_id || "", 
      netsuite_id: "",
      rereg_id: props.registration.id,
      term_condn: checked,
      late_reg : lateReg,
      student_signature : isSig,
      ip: ipAddress,
      student_type: studentType ?? -1,
      signature_date:parseInt(new Date(cDate).getTime()/1000)
    },
    validationSchema: Yup.object({
      student_type: Yup.number()
      .required("Interest area is required")
      .min(0, "Select a valid Student Type"),
      student_signature : Yup.mixed().required('Signature is required'),
      term_condn: Yup.bool().oneOf(
        [true],
        "Accept Terms & Conditions is required"
      ),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const hasRedo = (values.subjectRedo_.filter(item => item.subject!="").length > 0) || (parentSubjectRedoLength.filter(item => item.subject!="").length > 0)
      const hasReRegFound = (foundationReReg.filter(item => item.subject!="").length > 0)
      if(!hasRedo || hasReRegFound){
        values.subjectRedo_ = JSON.stringify(foundationReReg);
        values.foundation = true;
      }
      const hasProgress = foundationProgress?.[0]?.subject !== "";
      if(hasProgress){
        values.foundation = true;
      }
      values.subjectProgress_ = JSON.stringify(foundationProgress);
      setLoading(true);
      const formData = new FormData();
      values.netsuite_id = selectedNSId;
      // Append all values from the form
      const appendFormData = (data) => {
        Object.keys(data).forEach(key => {
          const value = data[key];
          
          if (Array.isArray(value)) {
            // For array values, stringify the entire array
            formData.append(key, JSON.stringify(value));
          } else if (typeof value === 'object' && value !== null) {
            if (value instanceof File) {
              // Handle file objects
              formData.append(key, value);
            } else {
              // Stringify other objects
              formData.append(key, JSON.stringify(value));
            }
          } else {
            // Append primitive values directly
            formData.append(key, value);
          }
        });
      };
      
      appendFormData(values)
      submitReRegistrationService(formData).then((res) => {
        Swal.fire({
          icon: "success",
          title: "Successfully Submitted",
          text: "This does not confirm approval of your re-registration!!",
          timer: 3000,
          onOpen: function () {
            Swal.showLoading();
          },
        }).then(function (result) {
          setLoading(false);
          setStudentNewRegId(res.data.studentNewRegId);
          setReadOnly(true);
          props.updateStatus();
          if(isReReg.isReReg===true){
            dispatch(setReRegistrationsReload(!reload));
            history.push("/reregStatus");
          }
        })
      }).catch(err => {
        setLoading(false);
        console.log("StandardReReg -> submitReRegistration: Error",err)
      })
      ;
    },
  });
  
  const handleCancel = () => {
    setIsCancel(true)
    setIpAddress(false)
    setCDate(false)
    setIsSig("")
    setChecked(false)
    setParentSubjectRedoLength([{ subject: "" }])
    
    setTimeout(() => {
      setIsCancel(false);
    }, 100);
  }
  
  useEffect(() => {
    if (!regid) return;
    
    const source = axios.CancelToken.source();
    
    getFoundationOptions(
      regid,
      setFoundationOptions,
      qualificationDetails?.type || null,
      qualificationDetails?.campus || null,
      { cancelToken: source.token } // pass token to your request
    );
    
    return () => {
      source.cancel('Request canceled due to component unmount or regid change');
    };
  }, [regid, qualificationDetails]);
  
  return (
    <>
    <form onSubmit={formik.handleSubmit}>
    <div className="card-body disabled">
    <div className="theme-form application-form">
    <div className="row">
    <StudentTypeButton 
    disabled={false}
    setStudentType={setStudentType}
    formik={formik}
    setParentSubjectRedoLength={setParentSubjectRedoLength}
    setFoundProgress={setFoundProgress}
    setDisableProgress={setDisableProgress}
    setFoundReReg={setFoundReReg}
    />
    {(Number(formik.values.student_type)  === 0 || Number(formik.values.student_type)  === 2) && (
      <>
      <div className="form-group col-sm-12 inputfield">        
      <h5 className="textdanger heading-5">Re-registering for Failed Modules:</h5>
      <label>
      Please select the subjects you wish to re-register for. These are subjects you did not pass or would like to attempt again. If you do not wish to repeat any subjects, simply leave this section blank.<br/><br/>
      </label>
      <RedoSubject
      formik={formik}
      setParentSubjectRedoLength={setParentSubjectRedoLength}
      parentSubjectRedoLength={parentSubjectRedoLength}
      reRegSubject={reRegSubject}
      handleDisableField={() => {}}
      />
      </div>  
      </>  
    )}
    {Number(formik.values.student_type) === 1 && foundationOptions?.length > 0 && (
      <div className="form-group col-sm-12 inputfield">
      <h5 className="textdanger heading-5">Programme Articulation:</h5>
      <p>If you have successfully completed your current qualification, please indicate the programme you wish to articulate into for your next level of study.</p>
      {foundationProgress.map((val, idx) => (
        <div className="row" key={"progress" + idx}>
        <div key={"progress" + idx} className="col-sm-6">
        <select
        className="form-control"
        value={val.subject}
        onChange={(e) => handleFoundProgressChange(idx, e.target.value)}
        disabled={disableProgress}
        >
        <option value="">---</option>
        {foundationOptions?.map((opt) => (
          <option key={opt.id} value={opt.id}>
          {opt.label}
          </option>
        ))}
        </select>
        </div>
        </div>
      ))}
      </div>
    )}
    <div className="form-group col-sm-12 inputfield">
    
    <DigitalSignatureComponent isCancel={isCancel} formik={formik} signaturePadRef={signaturePadRef} fileInputRef={fileInputRef} cDate={cDate} ipAddress={ipAddress} setIpAddress={setIpAddress} setCDate={setCDate} setIsSig={setIsSig}/>
    </div>
    
    </div>
    <div className="col-12 form-group inputfield">
    <div className="custom-control custom-checkbox text-left box-tm">
    <input
    className={
      "custom-control-input " +
      (formik.touched.term_condn && formik.errors.term_condn
        ? " is-invalid"
        : "")
      }
      type="checkbox"
      name="term_condn"
      onChange={(e) => handleCheck(e)}
      onBlur={formik.handleBlur}
      checked={checked}
      id="customCheck1"
      />
      
      <label
      className="custom-control-label textdanger"
      htmlFor="customCheck1"
      >
      I hereby confirm that I have read, understood and accepted
      all <TextLink href={registration?.linkTandC} target="_blank">Terms and Conditions</TextLink> as set out in the application form that the above subject selections are correct, and understand
      that there may be changes made based on the academic outcome.
      </label>
      {formik.touched.term_condn && formik.errors.term_condn ? (
        <div className="invalid-feedback">
        {formik.errors.term_condn}
        </div>
      ) : null}
      </div>
      </div>
      </div>          
      <div className="Fmfooter">
      <StandardButton
        variant="primary"
        title="Submit"
        type="submit"
        disabled={loading}
      >
        {loading && <i className="fal fa-cog fa-spin"></i>} Submit
      </StandardButton>
        </div>         
        </div>
        </form>
        </>
      );
    }
    export default StandardReReg;
    